import { GetterTree } from 'vuex';
import { EntraJobsState } from './types';
import { RootState } from '../../types';
import {
  vmeSingleCompanyAdminGroup,
  vmeGlobalAdminGroup,
  vmeGlobalAdminGroupId,
  vmeSupportGroup,
  vmeSupportGroupId,
} from '@/shared/backend/account';
import GeneralUtils from '@/shared/utils/generalUtils';
import { CONST } from '@/shared/utils/Constants';
import router from '@/router';
import { EntraJobsSearchData } from '../../../model/smallPayloadModels/entrajobsSearchData';

export const getters: GetterTree<EntraJobsState, RootState> = {
  ['getEntraJobs']: (state) => state.entraJobDetailLog,
  ['getEntraJobsSearchData']: (state) => state.entraJobsSearchData,
  ['getEntraJobsSearchParams']: (state) => state.entraJobDetailLog?.searchParams,
  ['isEntraJobsSearchDataEmpty']: (state) => {
    const searchData: EntraJobsSearchData = state.entraJobsSearchData;
    let hasAction = searchData.action?.length > 0;
    let hasEntity = searchData.entity?.length > 0;
    let hasJobName = searchData.jobName?.length > 0;
    let hasTimestamp = !!searchData.timestamp;
    let isEmpty = !hasAction && !hasEntity && !hasJobName && !hasTimestamp;
    return isEmpty;
  },
  getUpdatingUsersData(state): any {
    return state.updatingUsersData;
  },

  getUpdatingUsers(state): boolean {
    return state.updatingUsers;
  },
};
